// extracted by mini-css-extract-plugin
export default {"TextMessageHouseNotPresent":"MessageHouseNotPresent_TextMessageHouseNotPresent__90rHM"};